<template>
    <ValidationObserver :ref="stepName" v-slot="observer">
        <EvoKeyboard :key="field_name" :name="field_name" :field="field" :step="step"></EvoKeyboard>
    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import EvoKeyboard from "../../../../fields/EvoKeyboard";
import {MaskPattern} from "../../../../../../models/fields/Features/mask/MaskPattern"
import {Text} from "../../../../../../models/fields/Text";
import EvoPhoneText from "../../../../fields/EvoPhoneText";

export default {
    components: {EvoKeyboard},
    mixins: [mixin,form_step_mixin],
    data() {
        return {
            field_name: 'phone',
            field: {
                _mask: new MaskPattern('{+32} {4}00 000000').showPlaceholder('X'),
                _validation: {
                    regex: /^\+324(5|6|7|8|9)\d{7}$/,
                    required: {allowFalse: false}
                },
            }
        }
    },
    mounted() {
        if(this.$store.get('form_data/iban')==this.$store.get('func_data/test_iban')){
            this.$store.set('general_data/is_test',1);
            this.field._mask = new MaskPattern('{+}[0000000000000000]');
            this.field._validation = {
                required: {allowFalse:false}
            }
        }else{
            this.$store.set('general_data/is_test',0);
        }
    }
}
</script>
